<template>
    <a href="#" class="ec-compare-remove-button" @click="remove()">
        <i class="ec-icon ec-icon-cross"></i>
    </a>
</template>

<style lang="scss" type="text/scss">
    @import "../../../sass/variables";
    @import "../../../sass/mixins";

    a.ec-compare-remove-button {
        color: $ec-bike-info-foreground;
        font-size: $ec-font-size-small;
        cursor: pointer;
        position: relative;

        .ec-icon {
            font-size: $ec-icon-height-small;
            font-weight: bold;
            display: inline-block;
        }

        &:hover {
            .ec-icon {
                @include ec-spin();
            }
        }
    }
</style>

<script type="text/babel">
    export default {
        props: ['bikeId'],

        methods: {
            remove: function () {
                this.$store.commit('removeBikeId', this.bikeId);

                let index = $(this.$el).parents('td').prevAll().length + 1;

                let $table = $(this.$el).parents('table');

                let $column = $('td:nth-child(%s)'.replace('%s', index), $table);

                let numColumns = $(this.$el).parents('td').siblings().length;

                $column.remove();

                if (numColumns > 1) {
                    // Fix container width so that scroll does not change
                    $('.ec-js-comparison-scroll-handler').children().width((numColumns * 20.5) + 'vw');
                }
                else {
                    // Last column removed, hide table and show info message
                    $('.ec-js-no-content').removeClass('hidden');
                    $('.ec-js-comparison-scroll-handler').addClass('hidden');
                }
            }
        }
    }
</script>